<template lang="pug">
  #what-they-say-about-us
    h2.section-title.light O que falam da #[strong Revisacar]
    .content
      blockquote.testimony {{ activeTestimony }}
      .users
        a.user(v-for="testimony in testimonies", :class="{ active: isActiveTestimony(testimony) }", @click="setActiveTestimony(testimony.id)")
          img(:src="testimony.userPhoto")
          h4.name {{ testimony.userName }}
          span.description {{ testimony.userDescription }}
</template>

<script>
export default {
  name: 'WhatTheySayAboutUs',
  data: () => ({
    testimonies: [
      {
        id: 1,
        userPhoto: require("@/assets/images/testimoniesUsers/thiago.jpg"),
        userName: "Thiago Nogueira",
        userDescription: "Professor",
        userTestimony: "O atendimento é excelente e os preços são ótimos. A localização também é um grande atrativo. Mas, o que mais agrada são os preços justos, que garantem um serviço de qualidade, com garantia e dentro de um bom prazo, sem que o cliente precise pagar valores absurdos",
        active: false,
      },
      {
        id: 2,
        userPhoto: require("@/assets/images/testimoniesUsers/julio.jpg"),
        userName: "Júlio Filho",
        userDescription: "Programador",
        userTestimony: "Atendimento de qualidade! É uma oficina em que eu confio por causa da competência dos funcionários.",
        active: true,
      },
      {
        id: 3,
        userPhoto: "https://randomuser.me/api/portraits/men/62.jpg",
        userName: "teste",
        userDescription: "Dentista",
        userTestimony: "labore et dolore magna aliqua lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.",
        active: false,
      }
    ],
    activeTestimony: ''
  }),
  created() {
    this.getActiveTestimony()
  },
  methods: {
    isActiveTestimony(testimony) {
      if (testimony.active) {
        return true
      }
      return false
    },
    getActiveTestimony() {
      this.testimonies.forEach(testimony => {
        if (testimony.active) {
          this.activeTestimony = testimony.userTestimony
        }
      })
    },
    setActiveTestimony(id) {
      this.testimonies.forEach(testimony => {
        if (testimony.id === id) {
          testimony.active = true
        } else {
          testimony.active = false
        }
      })
      this.getActiveTestimony()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/resources'

#what-they-say-about-us
  float left
  width 100%
  height 100%
  display flex
  flex-direction column
  background-color black

  .content
    width 700px
    flex 1
    display flex
    flex-direction column
    justify-content center
    margin 0 auto

    .testimony
      font-size 16px
      padding .75em
      quotes "“""”""‘""’  "
      color rgba(white, .7);

      &:before
        content open-quote
        color white
        font-size 6em
        line-height .1em
        vertical-align -.4em
        margin-right 5px

      &:after
        content close-quote
        color white
        font-size 6em
        line-height .1em
        vertical-align -.7em
        margin-left 5px

    .users
      width 100%
      display flex
      justify-content center
      align-items center

      .user
        cursor pointer
        width 65px
        height 65px
        margin 0 15px
        opacity .4
        &:hover
          opacity .8

        .name
          color white
          font-size 15px
          margin 15px 0 0
          display none

        .description
          color white
          font-size 13px
          opacity .7
          display none

        &.active
          position relative
          width 150px
          border-radius 45px
          opacity 1

          img
            width 90px
            height 90px
            border-radius 45px

          &:after
            position absolute
            bottom -40px
            left 60px
            content "”"
            width 30px
            height 30px
            border-radius 15px
            background-color $revisacar-red
            font-size 3em
            font-family 'Raleway', sans-serif
            color white

          .name
            display block

          .description
            display block

        img
          width 100%
          height 100%
          border-radius 32.5px

@media (max-width: 1366px)
  #what-they-say-about-us
    .content
      width 90%
      margin 0 auto 50px

.slide-fade-enter-active
  transition all .2s ease

.slide-fade-leave-active
  transition all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0)

.slide-fade-enter, .slide-fade-leave-to
  transform translateX(10px)
  opacity 0
</style>



// WEBPACK FOOTER //
// src/components/WhatTheySayAboutUs.vue